import { createFileRoute } from '@tanstack/react-router';
import { useProject } from '@/features/projects/use-project';
import { requireTasksFeature } from '@/features/tasks/guard';
import { parseListSearch, withTask } from '@/features/tasks/list-search';
import { TaskList } from '@/features/tasks/task-list';
import { TaskPanel } from '@/features/tasks/task-panel';

/**
 * Task list of a project. Filters, sorting and grouping live in the URL (shareable, TASK-04);
 * `?task=KEY-1` opens the detail panel.
 */
export const Route = createFileRoute('/_app/p/$projectKey/tasks')({
  validateSearch: (raw: Record<string, unknown>) => parseListSearch(raw),
  beforeLoad: ({ context }) => requireTasksFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const project = useProject(projectKey);
  return (
    <>
      <TaskList
        project={project}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
      />
      <TaskPanel
        projectKey={project.key}
        taskKey={search.task}
        linkTo={(key) => ({
          to: '/p/$projectKey/tasks',
          params: { projectKey: project.key },
          search: withTask(search, key),
        })}
        onTaskChange={(key, options) => {
          void navigate({ search: withTask(search, key), replace: options?.replace === true });
        }}
      />
    </>
  );
}
